module.exports = __webpack_public_path__ + "static/All-Australians-735d93b8dce0e4ca04e2dc426ec28be6.svg";